import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import { NAME as commentTemplateReducerName } from "CommentTemplates/modules/CommentTemplatesModule";
export default store => ({
  path: ":studentProgressReportId",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "course-progressreport" */ "./components"),
        import(
          /* webpackChunkName: "course-progressreport" */ "MultiLevelNodeEditor/modules/MultiLevelNodeEditorModule"
        ),
        import(
          /* webpackChunkName: "course-progressreport" */ "CommentTemplates/modules/CommentTemplatesModule"
        ),
        import(
          /* webpackChunkName: "course-progressreport" */ "ProgressReport/modules/ProgressReportModule"
        ),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
        ]) => {
          const component = importedModule0.default;
          const multiLevelNodeEditorReducer = importedModule1;
          const commentTemplatesReducer = importedModule2;
          const progressReportReducer = importedModule3.default;
          injectReducer(store, {
            key: "progressReport",
            reducer: progressReportReducer,
          });
          injectReducer(store, {
            key: "multiLevelNodeEditor",
            reducer: multiLevelNodeEditorReducer.default,
          });
          injectReducer(store, {
            key: commentTemplateReducerName,
            reducer: commentTemplatesReducer.default,
          });
          return component;
        }
      )
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [],
});
